import { render } from "./Lastautumn.vue?vue&type=template&id=d927308e"
import script from "./Lastautumn.vue?vue&type=script&lang=js"
export * from "./Lastautumn.vue?vue&type=script&lang=js"

import "./Lastautumn.vue?vue&type=style&index=0&id=d927308e&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__